import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { jumpPoints } from '../data/mockData';
const toneClasses = {
  default: 'border-gray-200',
  danger: 'border-danger/40',
  warn: 'border-amber-300'
} as const;
const valueClasses = {
  default: 'text-ink',
  danger: 'text-danger',
  warn: 'text-amber-600'
} as const;
export function JumpPoints() {
  const navigate = useNavigate();
  return <section aria-label="Jump points" data-id="element-109" data-mp="o74oe2f0kzc2">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-110" data-mp="t5z8d7opwtxr">
        {jumpPoints.map(point => <button key={point.id} type="button" onClick={() => navigate(point.to)} className={['group rounded-xl border bg-white px-5 py-4 text-left transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-brand/30', toneClasses[point.tone]].join(' ')} data-id="element-111" data-mp="ehbdl3mp4o8v">
            <div className="flex items-center gap-2" data-id="element-112" data-mp="m4fy8rkphevl">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500" data-id="element-113" data-mp="m4z6fgkk0owf">
                {point.label}
              </p>
              <ArrowUpRightIcon className="ml-auto h-3.5 w-3.5 text-gray-300 transition-colors group-hover:text-brand" aria-hidden="true" data-id="element-114" data-mp="vu9030v1qfmn" />
            </div>
            <p className={['mt-2 text-3xl font-bold leading-none', valueClasses[point.tone]].join(' ')} data-id="element-115" data-mp="14uxgg27wws2p">
              {point.count}
            </p>
            <p className="mt-3 text-[12px] text-gray-500" data-id="element-116" data-mp="1esbujv6d54ru">{point.caption}</p>
          </button>)}
      </div>
    </section>;
}